import React from 'react'

const LogsPreLoader = () => {
  return (
    <div className='progress blue lighten-4'>
        <div className="indeterminate"></div>
    </div>
  ) 
}

export default LogsPreLoader